"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maybeFetchDateTimeFormatOptions = void 0;

var _of = require("rxjs/observable/of");

var _filter = require("rxjs/operators/filter");

var _map = require("rxjs/operators/map");

var _mergeMap = require("rxjs/operators/mergeMap");

var _selectors = require("settings-ui-sdk/Auth/selectors");

var _actions = require("settings-ui-sdk/BlogLanguages/actions");

var _constants = require("settings-ui-sdk/SiteSettings/constants");

var _UpdateEmailSiteSettings = _interopRequireDefault(require("../stagedObjects/UpdateEmailSiteSettings"));

var fetchDateTimeFormatOptionsOnTheseActions = [_UpdateEmailSiteSettings.default.getStageForEditActionType(), _UpdateEmailSiteSettings.default.getChangePropertyActionType(_constants.EMAIL_RSS_DATE_FORMAT), _UpdateEmailSiteSettings.default.getChangePropertyActionType(_constants.EMAIL_RSS_DATE_LANGUAGE)];

var maybeFetchDateTimeFormatOptions = function maybeFetchDateTimeFormatOptions($action, _ref) {
  var getState = _ref.getState;
  return $action.pipe((0, _filter.filter)(function (action) {
    return fetchDateTimeFormatOptionsOnTheseActions.indexOf(action.type) !== -1;
  }), (0, _filter.filter)(function () {
    return (0, _selectors.getUserScopes)(getState()).includes('content-access');
  }), (0, _map.map)(function () {
    return {
      language: _UpdateEmailSiteSettings.default.getStagedProperty(_constants.EMAIL_RSS_DATE_LANGUAGE)(getState()),
      selectedFormat: _UpdateEmailSiteSettings.default.getStagedProperty(_constants.EMAIL_RSS_DATE_FORMAT)(getState())
    };
  }), (0, _mergeMap.mergeMap)(function (_ref2) {
    var language = _ref2.language,
        selectedFormat = _ref2.selectedFormat;
    return (0, _of.of)((0, _actions.loadDateTimeFormatOptions)(language, selectedFormat));
  }));
};

exports.maybeFetchDateTimeFormatOptions = maybeFetchDateTimeFormatOptions;